import type { AnyID } from '@types'
import {
  isKubeCushion,
  isKubeSnapModule,
  isModularCornerSnapCatalog,
  isOreja,
  isPouff,
} from '@utils/sceneObjects/items/rinconeroUtils'

/** Snap 166-/oreja: motor completo (caras L, anti-solape). Fila recta: OGadapted. */
export function modularSnapNeedsFullEngine(dragCatalog: unknown, anchorCatalog: unknown): boolean {
  return (
    isModularCornerSnapCatalog(dragCatalog) ||
    isModularCornerSnapCatalog(anchorCatalog) ||
    isOreja(dragCatalog) ||
    isOreja(anchorCatalog)
  )
}

export type ModularCollideResult = { snapped: boolean; side: 'left' | 'right' | null }

export function collideModularLinkedItems(
  dragId: AnyID,
  anchorId: AnyID,
  getCatalog: (id: AnyID) => unknown,
  collideItems: (
    dragId: AnyID,
    anchorId: AnyID,
    options?: { forcedSide?: 'left' | 'right' },
  ) => ModularCollideResult,
  collidePouffItems: (
    dragId: AnyID,
    anchorId: AnyID,
    options?: { forcedSide?: 'left' | 'right' },
  ) => ModularCollideResult,
  options?: { forceReposition?: boolean },
): ModularCollideResult {
  const dragCatalog = getCatalog(dragId)
  const anchorCatalog = getCatalog(anchorId)
  // Cojines KUBE (K1C 040 040): colocación libre / encima de bases — sin snap lateral.
  if (isKubeCushion(dragCatalog) || isKubeCushion(anchorCatalog)) {
    return { snapped: false, side: null }
  }
  // Pouffs y módulos KUBE de sofá (K10BA, K1RB, …): snap a 4 lados + anti-solape.
  if (isPouff(dragCatalog) || isKubeSnapModule(dragCatalog)) {
    return collidePouffItems(dragId, anchorId)
  }
  return collideItems(dragId, anchorId, options as { forcedSide?: 'left' | 'right' } | undefined)
}
